import styled from "@emotion/styled";

import { ContentItemRender } from "~/components/content/content-item-render";
import { Summary } from "~/components/content/content-item-render/variants/home-secondary/styles";
import { HomeSponsorTagWrapper } from "~/components/sponsor-tag/styles";

export const StyledContentItemRender = styled(ContentItemRender)``;

export const Container = styled.div`
  ${HomeSponsorTagWrapper} {
    display: block;
  }

  ${Summary} {
    ${props => props.theme.breakpoints.only("mobile")} {
      display: none;
    }
  }
`;
